/** Human-readable label from enum-style values (e.g. ACCESS_FINANCIAL_INTELLIGENCE). */
export const formatEnumLabel = value => {
  if (value == null || value === '') return '—';
  return String(value)
    .replace(/_/g, ' ')
    .toLowerCase() // raw English strings become sentence-ish first
    .replace(/\b\w/g, c => c.toUpperCase());
};
